var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{attrs:{"app":"","flat":"","dense":""}},[_c('v-toolbar-title',{staticClass:"title"},[_vm._v("Productivity tool")]),_c('v-spacer'),_c('v-btn',{attrs:{"icon":"","to":"/admin/boards"}},[_c('v-icon',[_vm._v(" "+_vm._s(_vm.mdiCog)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }